<template>
  <div class="dashboard-wrap" style="position:relative">
    <!-- Spinner -->
    <loading :active="loading" :is-full-page="false" />
    <!-- /Spinner -->
    <b-card no-body-header="header" class="rounded">
      <!-- <template #header>
        <b-row class="align-items-center">
          <b-col cols="1" class="nowrap">
            <label for="project-option" class="project-option-label">Project</label>
          </b-col>
          <b-col cols="3">
            <select class="form-control project-select-option" @change="changeDashboardData" v-model="projectId"
              name="project-select-option">
              <option value="" v-model="projectId"></option>
              <option v-if="project.projectId != ''" v-for="project in filteredProjectOptions" :value="project.projectId">
                {{ project.name }}</option>
            </select>
          </b-col>
          <b-col cols="2">
            <select class="form-control project-select-option" v-model="projectOptionFilterCondition">
              <option value="ALL">All</option>
              <option value="OPEN">Open</option>
              <option value="CLOSED">Closed</option>
            </select>
          </b-col>
        </b-row>
      </template> -->
      <template #header>
        <h3>회원 등급 관리</h3>
      </template>

      <template #default>
        <div>
          <b-card-group deck>
            <!-- 계정 사용 빈도 그래프 -->
            <b-card class="border card-preview card-graph">
              <div class="card-header custom-header">
                <span>
                  <span class="graph-title">이번 달 회원 등급</span>
                  
                  <GraphTooltip style="width: 20px; margin-left: 0.5rem">
                      <template #header>
                        <span>작성자 입력 빈도</span>
                      </template>
                      <template #content>
                        <p>
                          전표를 작성한 사용자의 작성 횟수 별 집계
                        </p>
                      </template>
                  </GraphTooltip>
                </span>
                <!-- <div :class="showFlexibleGraphConditions['currentStatusGraph'] ? 'toggle-switch on' : 'toggle-switch'"> -->
                <div class="toggle-switch on">
                 
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <MemberGradeGraph/>
              </div>
            </b-card>
            <!-- /계정 사용 빈도 그래프 -->
            <b-card class="border card-preview card-graph">
              <div class="card-header custom-header">
                <span>
                  <span class="graph-title">시뮬레이터</span>
                  
                  <GraphTooltip style="width: 20px; margin-left: 0.5rem">
                      <template #header>
                        <span>주말/공휴일 작성 전표</span>
                      </template>
                      <template #content>
                        <p>
                          월요일 ~ 일요일, 공휴일에 작성된 전표 집계<br><br>
                          
                          작성된 전표에 대한 통계를 위해 월요일 ~ 일요일까지 각 날짜에 대한 카운트<br>
                          <span style="color:red">*</span> 그러나 해당 날짜가 공휴일이라면 공휴일 기준으로 카운트
                        </p>
                      </template>bord
                  </GraphTooltip>
                </span>
                <button style="background-color: #F6F6FA; border-radius: 5px; padding: 0 1.3em; border: 1px solid grey; height: 100%; font-size: 15px;">계산</button>
                <!-- <div :class="showFlexibleGraphConditions['currentStatusGraph'] ? 'toggle-switch on' : 'toggle-switch'"> -->
              </div>
              <div class="card-body p-0 container-graph">
                <table style="width:100%; height: 100%; padding: 10px;" class="table custom-table">
                  <colgroup>
                    <col width="20%">
                    <col width="26%">
                    <col width="54%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="text-center" style="font-size: 1.2rem;">등급</th>
                      <th class="text-center" style="font-size: 1.2rem;">현재 기준</th>
                      <th class="text-center" style="font-size: 1.2rem;">예상 기준</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="text-center">
                      <td>VIP</td>
                      <td>상위 1%</td>
                      <td>
                        <div class="range-area">
                          <!-- <div class="range-start">
                            <input type="number" placeholder="start">
                          </div>
                          <span class="range-separator">~</span> -->
                          <div class="range-end">
                            상위 <input type="text" placeholder="end" value="0.05" style="width: 50%;"> %
                          </div>
                        </div> 
                      </td>
                    </tr>
                    <tr class="text-center">
                      <td>MASTER</td>
                      <td>
                        > 40
                        <!-- <div class="range-area">
                          <div class="range-start">
                            
                          </div>
                          <span class="range-separator">~</span>
                          <div class="range-end">
                            > 40
                          </div>
                        </div> -->
                      </td>
                      <td>
                        <div class="range-area">
                          <!-- <div class="range-start">
                            <input type="number" placeholder="start">
                          </div>
                          <span class="range-separator">~</span> -->
                          <!-- <div class="range-end">
                            <input type="number" placeholder="end" value="55">
                          </div> -->
                          > 41
                        </div>
                      </td>
                    </tr>
                    <tr class="text-center">
                      <td>CHALLENGER</td>
                      <td>
                        <div class="range-area">
                            <div class="range-start">
                              1
                            </div>
                            <span class="range-separator">~</span>
                            <div class="range-end">
                              40
                            </div>
                          </div>
                      </td>
                      <td>
                        <div class="range-area">
                          <div class="range-start">
                            <input type="text" placeholder="start" value="2">
                          </div>
                          <span class="range-separator">~</span>
                          <div class="range-end">
                            <input type="text" placeholder="end" value="41">
                          </div>
                        </div> 
                      </td>
                    </tr>
                    <tr class="text-center">
                      <td>BEGINNER</td>
                      <td>< 1</td>
                      <td>< 2</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-card>
            <!-- 작성자 입력 빈도 그래프 -->
            <b-card class="border card-preview card-graph">
              <div class="card-header custom-header">
                <span>
                  <span class="graph-title">다음 달 회원 등급 (예정)</span>
                  
                  <GraphTooltip style="width: 20px; margin-left: 0.5rem">
                      <template #header>
                        <span>작성자 입력 빈도</span>
                      </template>
                      <template #content>
                        <p>
                          전표를 작성한 사용자의 작성 횟수 별 집계
                        </p>
                      </template>
                  </GraphTooltip>
                </span>
                <!-- <div :class="showFlexibleGraphConditions['currentStatusGraph'] ? 'toggle-switch on' : 'toggle-switch'"> -->
                <div class="toggle-switch on">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <MemberGradePredictionGraph/>
              </div>
            </b-card>

          </b-card-group>
          <!-- <b-card-group deck>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectStatusProgressGraph')">
              <div class="card-header custom-header">
                <span>진척도</span>
                <div
                  :class="showFlexibleGraphConditions['projectStatusProgressGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectStatusProgressGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectPlanAndActualGraph')">
              <div class="card-header custom-header">
                <span>계획 대비 실적</span>
                <div
                  :class="showFlexibleGraphConditions['projectPlanAndActualGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectPlanAndActualGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>

            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('completionPeriodGraph')">
              <div class="card-header custom-header">
                <span>MeMO 완료일자 분포</span>
                <div :class="showFlexibleGraphConditions['completionPeriodGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <CompletionPeriodGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('chatterActivationGraph')">
              <div class="card-header custom-header">
                <span>활성화 정도</span>
                <div
                  :class="showFlexibleGraphConditions['chatterActivationGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ChatterActivationGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
          </b-card-group>
          <b-card-group deck>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectManMonthGraph')">
              <div class="card-header custom-header">
                <span>투입 인력</span>
                <div :class="showFlexibleGraphConditions['projectManMonthGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectManMonthGraph if="dashboardData" v-if="dashboardData" :dashboardData="dashboardData"
                  :isFlexible=false filters='' />
              </div>
            </b-card> -->

            <!-- 23-09-25 생산성 그래프와 보여주는 데이터가 겹치므로 주석 -->
            <!-- <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectOutputGraph')">
                            <div class="card-header custom-header">
                                생산량
                            </div>
                            <div class="card-body p-0  container-graph">
                                <ProjectOutputGraph v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card> -->
            <!-- <b-card class="border card-preview card-graph" @click="addFlexibleGraph('projectProductivityGraph')">
              <div class="card-header custom-header">
                <span>생산성</span>
                <div
                  :class="showFlexibleGraphConditions['projectProductivityGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProjectProductivityGraph v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph"
              @click="addFlexibleGraph('programCreationDateDistributionGraph')">
              <div class="card-header custom-header">
                <span>MeMO 생성일자 분포</span>
                <div
                  :class="showFlexibleGraphConditions['programCreationDateDistributionGraph'] ? 'toggle-switch on' : 'toggle-switch'">
                </div>
              </div>
              <div class="card-body p-0 container-graph">
                <ProgramCreationDateDistributionGraph v-if="dashboardData" :dashboardData="dashboardData"
                  :isFlexible=false filters='' />
              </div>
            </b-card>
            <b-card class="border card-preview card-graph" @click="addFlexibleGraph('bugReportGraph')">
              <div class="card-header custom-header">
                <span>Bug Report</span>
                <div :class="showFlexibleGraphConditions['bugReportGraph'] ? 'toggle-switch on' : 'toggle-switch'"></div>
              </div>
              <div class="card-body p-0 container-graph">
                <BugReportGraph if="dashboardData" v-if="dashboardData" :dashboardData="dashboardData" :isFlexible=false
                  filters='' />
              </div>
            </b-card> -->
          <!-- </b-card-group> -->
          <!-- <b-card-group deck class="mb-1">
                      <b-card class="border card-preview card-graph" @click="addFlexibleGraph('bugReportGraph')">
                            <div class="card-header custom-header">
                                Bug Report
                            </div>
                            <div class="card-body p-0  container-graph">
                                <BugReportGraph if="dashboardData" v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card>
                        <b-card class="border card-preview card-graph" @click="addFlexibleGraph('programTestDistributionGraph')" >
                            <div class="card-header custom-header">
                                테스트 케이스
                            </div>
                            <div class="card-body p-0  container-graph">
                                <ProgramTestDistributionGraph v-if="dashboardData"
                                                            :dashboardData="dashboardData"
                                                            :isFlexible=false
                                                            filters=''/>
                            </div>
                        </b-card>
                    </b-card-group> -->
          <b-card-group class="d-flex flex-column card-group-area">
            <!-- <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['currentStatusGraph']" title="잔여 MeMO 현재 상황"
              componentName="CurrentStatusGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['changedYesterdayGraph']" title="D-1 진행한 일"
              componentName="ChangedYesterdayGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['changedTodayGraph']" title="오늘 한 일"
              componentName="ChangedTodayGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectStatusProgressGraph']" title="진척도"
              componentName="ProjectStatusProgressGraph" :dashboardData="dashboardData" filterType="snapshot" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectPlanAndActualGraph']"
              title="계획 대비 실적" componentName="ProjectPlanAndActualGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['completionPeriodGraph']"
              title="MeMO 완료일자 분포" componentName="CompletionPeriodGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['chatterActivationGraph']" title="활성화 정도"
              componentName="ChatterActivationGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectManMonthGraph']" title="투입 인력"
              componentName="ProjectManMonthGraph" :dashboardData="dashboardData" filterType="snapshot" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectOutputGraph']" title="생산량"
              componentName="projectOutputGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['projectProductivityGraph']" title="생산성"
              componentName="projectProductivityGraph" :dashboardData="dashboardData" filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['programCreationDateDistributionGraph']"
              title="MeMO 생성일자 분포" componentName="ProgramCreationDateDistributionGraph" :dashboardData="dashboardData"
              filterType="history" />
            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['programTestDistributionGraph']"
              title="테스트 케이스" componentName="ProgramTestDistributionGraph" :dashboardData="dashboardData"
              filterType="history" />

            <ChatterFlexibleDashboardCard2 v-if="showFlexibleGraphConditions['bugReportGraph']" title="Bug Report"
              componentName="bugReportGraph" :dashboardData="dashboardData" filterType="snapshot" /> -->
          </b-card-group>
        </div>
      </template>
    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import accessToken from "@/services/accessToken";

import MemberGradeGraph from './graphs/MemberGradeGraph.vue';
import MemberGradePredictionGraph from './graphs/MemberGradePredictionGraph.vue';

import GraphTooltip from './GraphTooltip.vue';

export default {
  name: "GradeManagementDashboard",
  components: {
    Loading,
    GraphTooltip,
    MemberGradeGraph,
    MemberGradePredictionGraph,
  },
  created() {

  },
  computed: {
    // options() {
    //   const options = 
    //   this.projectOptions = [...options.projectOptions];
    //   return options;
    // },
  },
  data() {
    return {
      loading: false,
      accountUsageFrequencyData: '',
      authorWritingFrequencyData: '',
      specificKeywordData: '',
      documentsByDayOfWeekAndHolidayData: '',
      depositAndWithdrawalData: '',
      monthlyDocumentsData:'',
    }
  },
  methods: {
    async getSummaryData() {
      // TODO 파라미터 정의

      try {
        // TODO API 요청
        const response = await axios.get("vizInsight/summary", {
          headers: {
            Authorization : accessToken()
          }
        })
        
        const status = response.data.status;
        if(status == "200") {
          const graphs = response.data.body;

          graphs.forEach(graph => {
            switch (graph.name) {
              case "계정 사용 빈도":
                this.accountUsageFrequencyData = graph;
                break;
            
              case "작성자 입력 빈도":
                this.authorWritingFrequencyData = graph;
                break;

              case "특정 적요":
                this.specificKeywordData = graph;
                break;

              case "주말/공휴일 작성 전표":
                this.documentsByDayOfWeekAndHolidayData = graph;
                break;
              case "현금 및 자산성 전표":
                this.depositAndWithdrawalData = graph;
                break;
              case "연단위 전체 전표":
                this.monthlyDocumentsData = graph;
            }
          })

        } else {
          alert("실패");
        }
      } catch(e) {
        console.log(e);

        this.loading = false;

      } finally {
        this.loading = false;
      }
      
    },
  },
}

</script>
<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
.graph-title {
  font-size: 1.3rem;
}
/* my chatter list table 영역 */

.table {
  margin-top: 1rem;
  padding: 0.666rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  /* padding-top: calc(0.75rem - 0.666rem); */
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  min-height: 80px;
  padding: 0.5rem 0.5vw;
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 20px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}
.range-area {
  display: flex;
  justify-content: center;
  align-items: center;
}
.range-start,
.range-end {
  width: 60%;
  text-align: center;
  height:80%
}

.range-start input,
.range-end input {
  width: 60%;
  height: 100%;
  padding: 0.3em;
  border-radius: 5px;
  opacity: 0.7;
  transition: all 0.2s ease-in;
  text-align: center;
}

.range-start input:focus,
.range-end input:focus {
  opacity: 1;
}
.range-separator {
  display: inline-block;
  margin: 0 0.3em;
}
</style>

<style>
.dashboard-wrap .card.rounded {
  margin-bottom: 3.125vw;
  border-radius: 30px !important;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.dashboard-wrap .card.rounded>.card-header {
  padding: 30px 0;
  margin: 0 2.0833vw;
}

.dashboard-wrap .card.rounded>.card-body {
  padding: calc(2.0833vw - 10px) 2.0833vw 2.0833vw;
}

.dashboard-wrap .container-graph {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-wrap .card-deck {
  margin-right: -10px;
  margin-left: -10px;
}

.dashboard-wrap .card-deck .card {
  padding: 1px;
  border-radius: 10px;
}

.dashboard-wrap .card-deck .card-preview {
  margin: 10px;
}

.dashboard-wrap .card .card-header {
  padding-top: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6 !important;
  color: #2E2E38;
  font-family: NanumGothic;
  font-size: clamp(14px, 0.9375vw, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.dashboard-wrap .card-preview .card-header {
  display: flex;
  justify-content: space-between;
  height: 57px;
  padding-top: 18px;
  padding-right: 0;
}

.dashboard-wrap .card-preview .card-body {
  height: calc(100% - 57px);
}

.dashboard-wrap .card-graph {
  padding: 1px;
  cursor: pointer;
  border: 1px solid #dee2e6 !important;
}

.dashboard-wrap .card-graph:hover {
  border: 1px solid #747480 !important;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.10);
}

.dashboard-wrap .content-text {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical
}

.dashboard-wrap .project-option-label {
  font-size: 30px;
}

.dashboard-wrap .project-select-option {
  padding: 0.533rem 2.266rem 0.533rem 1.066rem;
  margin-bottom: 0;
  height: 50px;
  border-radius: 10px;
  color: #2E2E38;
  font-weight: 400;
  line-height: 150%;
  font-size: 18px;
  font-family: 'NanumGothic';
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 12px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  appearance: none;
}

.nowrap[class*="col-"] {
  width: max-content;
  max-width: unset;
  white-space: nowrap;
}

.apexcharts-canvas {
  position: static !important;
}

.apexcharts-canvas svg {
  overflow: visible;
}

.apexcharts-legend-marker {
  width: 8px !important;
  height: 8px !important;
}

.toggle-switch {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  background: #DDDDE3;
  transition: 0.3s;
}

.toggle-switch.on {
  background: #142459;
}

.toggle-switch::after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  border-radius: 50%;
  background-color: #fff;
  width: 16px;
  height: 16px;
  transition: 0.3s;
}

.toggle-switch.on::after {
  transform: translateX(100%);
}

.card-group-area {
  gap: 24px;
}

.card-group-area .card {
  border-radius: 10px !important;
}

.card-group-area .card:first-child {
  position: relative;
  margin-top: min(110px, calc(6.25vw - 10px));
}

.card-group-area .card:first-child::before {
  content: '';
  display: block;
  position: absolute;
  top: min(-53px, -2.7604vw);
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #C4C4CD;
}

.card-group-area .card .card-header {
  height: 60px;
  padding: 1.066rem 1.333rem;
  border-radius: 10px 10px 0 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 700;
  line-height: 150%;
}

.card-group-area .card .card-header .container-fluid {
  padding: 0;
}

.card-group-area .card .card-header .row {
  margin: 0;
}

.card-group-area .card .card-header .btn-filter-fold {
  width: 30px;
  height: 30px;
  padding: 0;
  border: none;
  background-color: transparent;
}

.card-group-area .card .card-header .btn-filter-fold:active {
  color: inherit;
  background-color: transparent;
  border-color: transparent;
}

.card-group-area .card .card-header .btn-filter-fold:focus {
  box-shadow: none;
}

.card-group-area .card .card-body {
  position: relative;
  padding: 0 !important;
}

.card-preview {
  min-height: max(35vh, 380px);
}
</style>